import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const TdsStatusUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick, account
}) => {
  const enableTds = !(account && account.tdsStatus)
  const actionLabel = enableTds ? 'Enable' : 'Disable'

  return (
    <ModalFormUI
      context={context}
      titleLabel='Update TDS Status'
      buttonLabel={actionLabel}
      cancelLabel='Cancel'
      isOpen={updateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div className='g_small'>
        {`Do you want to ${actionLabel.toLowerCase()} TDS status for this account?`}
      </div>
    </ModalFormUI>
  )
}

export default TdsStatusUpdateModalUI
